import { useState, useCallback } from 'react';

import { useAsyncPaginateBase } from './useAsyncPaginateBase';

export const useAsyncPaginatePure = (
  useStateParam,
  useCallbackParam,
  useAsyncPaginateBaseParam,
  params,
  deps = []
) => {
  const {
    inputValue: inputValueParam,
    menuIsOpen: menuIsOpenParam,
    defaultInputValue: defaultInputValueParam,
    defaultMenuIsOpen: defaultMenuIsOpenParam,
    onInputChange: onInputChangeParam,
    onMenuClose: onMenuCloseParam,
    onMenuOpen: onMenuOpenParam,
  } = params;

  const [inputValueState, setInputValue] = useStateParam(defaultInputValueParam || '');
  const [menuIsOpenState, setMenuIsOpen] = useStateParam(!!defaultMenuIsOpenParam);

  const inputValue = typeof inputValueParam === 'string' ? inputValueParam : inputValueState;

  const menuIsOpen = typeof menuIsOpenParam === 'boolean' ? menuIsOpenParam : menuIsOpenState;

  const onInputChange = useCallbackParam(
    (nextInputValue, actionMeta) => {
      if (onInputChangeParam) {
        onInputChangeParam(nextInputValue, actionMeta);
      }

      setInputValue(nextInputValue);
    },
    [onInputChangeParam]
  );

  const onMenuClose = useCallbackParam(() => {
    if (onMenuCloseParam) {
      onMenuCloseParam();
    }

    setMenuIsOpen(false);
  }, [onMenuCloseParam]);

  const onMenuOpen = useCallbackParam(() => {
    if (onMenuOpenParam) {
      onMenuOpenParam();
    }

    setMenuIsOpen(true);
  }, [onMenuOpenParam]);

  const baseResult = useAsyncPaginateBaseParam(
    {
      ...params,
      inputValue,
      menuIsOpen,
    },
    deps
  );

  return {
    ...baseResult,
    inputValue,
    menuIsOpen,
    onInputChange,
    onMenuClose,
    onMenuOpen,
  };
};

export const useAsyncPaginate = (params, deps) =>
  useAsyncPaginatePure(useState, useCallback, useAsyncPaginateBase, params, deps);
